export const SET_KEY_OUTIN_RECORDS = 'KeyRecords/OutIn/set';
export const SET_KEY_LOST_RECORDS = 'KeyRecords/Lost/set';
